import { render, staticRenderFns } from "./index-fast.vue?vue&type=template&id=4c8364a2&scoped=true&"
import script from "./index-fast.vue?vue&type=script&lang=js&"
export * from "./index-fast.vue?vue&type=script&lang=js&"
import style0 from "./index-fast.vue?vue&type=style&index=0&id=4c8364a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8364a2",
  null
  
)

export default component.exports